export function normalizeProductionText(value) {
  if (value === null || value === undefined) {
    return "";
  }
  return String(value).trim().toLowerCase();
}

export function buildProductionSetFromCompanyApi(rows) {
  const map = new Map();
  if (!Array.isArray(rows)) {
    return map;
  }
  for (const row of rows) {
    const id = Number(row?.id);
    if (!Number.isFinite(id)) {
      continue;
    }
    map.set(id, {
      name: row.name_production ?? "",
      address: row.address_production ?? "",
    });
  }
  return map;
}

export function buildProductionSetFromReport(rows) {
  const map = new Map();
  if (!Array.isArray(rows)) {
    return map;
  }
  for (const row of rows) {
    const id = Number(row?.production_id);
    if (!Number.isFinite(id)) {
      continue;
    }
    map.set(id, {
      name: row.name ?? "",
      address: row.address ?? "",
      all_label_prod: Number(row.all_label_prod) || 0,
    });
  }
  return map;
}

function metadataDiffers(lkEntry, reportEntry) {
  const lkName = normalizeProductionText(lkEntry?.name);
  const lkAddr = normalizeProductionText(lkEntry?.address);
  const repName = normalizeProductionText(reportEntry?.name);
  const repAddr = normalizeProductionText(reportEntry?.address);
  return lkName !== repName || lkAddr !== repAddr;
}

/**
 * @param {Map<number, object>} P — площадки ЛК
 * @param {Map<number, object>} R — площадки отчёта
 * @param {Map<number, { company_id: number, name_production?: string, address_production?: string }>} globalCatalog
 * @param {Map<number, string>} companyNames
 * @param {number} companyId
 */
export function classifyProductionMismatch(P, R, globalCatalog, companyNames, companyId) {
  const extraInReport = [];
  const onlyInLk = [];
  const metadataMismatch = [];

  for (const [id, reportEntry] of R.entries()) {
    if (!P.has(id)) {
      const catalogRow = globalCatalog.get(id);
      const ownerCompanyId = catalogRow?.company_id ?? null;
      extraInReport.push({
        productionId: id,
        reportName: reportEntry.name,
        reportAddress: reportEntry.address,
        all_label_prod: reportEntry.all_label_prod,
        ownerCompanyId,
        ownerCompanyName:
          ownerCompanyId != null
            ? companyNames.get(ownerCompanyId) ?? `ID ${ownerCompanyId}`
            : "—",
        catalogName: catalogRow?.name_production ?? "",
        catalogAddress: catalogRow?.address_production ?? "",
      });
    }
  }

  for (const [id, lkEntry] of P.entries()) {
    if (!R.has(id)) {
      onlyInLk.push({
        productionId: id,
        lkName: lkEntry.name,
        lkAddress: lkEntry.address,
        likelyNoPrint: true,
      });
    }
  }

  for (const [id, lkEntry] of P.entries()) {
    const reportEntry = R.get(id);
    if (reportEntry && metadataDiffers(lkEntry, reportEntry)) {
      metadataMismatch.push({
        productionId: id,
        lkName: lkEntry.name,
        lkAddress: lkEntry.address,
        reportName: reportEntry.name,
        reportAddress: reportEntry.address,
        all_label_prod: reportEntry.all_label_prod,
      });
    }
  }

  const counts = {
    extraInReport: extraInReport.length,
    onlyInLk: onlyInLk.length,
    metadataMismatch: metadataMismatch.length,
  };

  const hasAnomalies =
    counts.extraInReport > 0 || counts.metadataMismatch > 0;

  return {
    extraInReport,
    onlyInLk,
    metadataMismatch,
    counts,
    hasAnomalies,
    companyId,
  };
}

export function buildGlobalProductionCatalog(rows) {
  const map = new Map();
  if (!Array.isArray(rows)) {
    return map;
  }
  for (const row of rows) {
    const id = Number(row?.id);
    if (!Number.isFinite(id)) {
      continue;
    }
    map.set(id, {
      company_id: Number(row.company_id),
      name_production: row.name_production ?? "",
      address_production: row.address_production ?? "",
    });
  }
  return map;
}
